var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-header-cell"},[_c('dropdown',{attrs:{"options":_vm.options,"value":_vm.value,"onChange":_vm.onChange,"placeholder":_vm.label,"header":" Order by","mode":"tableHeaderCell"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }